import BasePopover, { PopoverProps } from '@material-ui/core/Popover';

interface Props extends Omit<PopoverProps, 'open'> {
  isOpen: boolean;
}

const Popover: React.FC<Props> = ({ isOpen, anchorEl, children, ...props }) => {
  return (
    <BasePopover
      anchorEl={anchorEl}
      open={isOpen}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      elevation={0}
      {...props}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          ...(props.PaperProps?.style || {}),
        },
        ...props.PaperProps,
      }}
    >
      {children}
    </BasePopover>
  );
};

export default Popover;
